// extracted by css-extract-rspack-plugin
export default {"emptyState":"r6c8bM","createButton":"Wktviy"};